import { useUserStore } from "../../store/modules/user";
import { ServerName } from "../env";
import { AIStandardEndpoint } from "./serverName";

export const getWhitelistedDomains = () => {
  const store = useUserStore();

  const permitedServers = store.getLLMServers;
  const domains: string[] = [];
  if (ServerName !== "" && typeof ServerName === "string") {
    const { hostname } = new URL(ServerName);
    domains.push(hostname);
  }
  try {
    const llmEndpoints = Object.values(permitedServers);
    llmEndpoints.forEach((hostname) => {
      domains.push(hostname);
    });
  } catch (e: any) {
    console.log("Error", e);
  }
  domains.push("localhost");
  const { hostname } = new URL(AIStandardEndpoint);
  domains.push(hostname);
  return domains;
};
